import { render, staticRenderFns } from "./ConfigEtalon.vue?vue&type=template&id=0870a30e&"
import script from "./ConfigEtalon.vue?vue&type=script&lang=js&"
export * from "./ConfigEtalon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports